var map = {
	"./acrylic-tray-empty.jpg": 1150,
	"./acrylic-tray.jpg": 7226,
	"./beverage-coaster-empty.jpg": 4675,
	"./beverage-coaster.jpg": 5287,
	"./button-empty.jpg": 4876,
	"./button-no-label.jpg": 2023,
	"./button.jpg": 3952,
	"./cup-empty.jpg": 2242,
	"./cup.jpg": 7246,
	"./glass-coaster-empty.jpg": 4794,
	"./glass-coaster.jpg": 8710,
	"./keychain-empty.jpg": 4744,
	"./keychain-no-label.jpg": 5315,
	"./keychain.jpg": 76,
	"./luggage-tag-empty.jpg": 6461,
	"./luggage-tag.jpg": 8081,
	"./magnet-empty.jpg": 5506,
	"./magnet-no-label.jpg": 3461,
	"./magnet.jpg": 2126,
	"./pillow.jpg": 3111,
	"./round-clock.jpg": 2763,
	"./stone-coaster-empty.jpg": 2785,
	"./stone-coaster.jpg": 3221,
	"./stone-magnet-empty.jpg": 2194,
	"./stone-magnet-no-label.jpg": 8709,
	"./stone-magnet.jpg": 5870,
	"./tshirt-empty.jpg": 9112,
	"./tshirt.jpg": 9820,
	"./water-bottle-empty.jpg": 1350,
	"./water-bottle.jpg": 5554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7929;